var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuyingPlan(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 5,
    fill: "#67768E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5013 3.66406H9.5013C9.04106 3.66406 8.66797 4.03716 8.66797 4.4974V6.16406C8.66797 6.6243 9.04106 6.9974 9.5013 6.9974H14.5013C14.9615 6.9974 15.3346 6.6243 15.3346 6.16406V4.4974C15.3346 4.03716 14.9615 3.66406 14.5013 3.66406Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.332 5.33594H16.9987C17.4407 5.33594 17.8646 5.51153 18.1772 5.82409C18.4898 6.13665 18.6654 6.56058 18.6654 7.0026V18.6693C18.6654 19.1113 18.4898 19.5352 18.1772 19.8478C17.8646 20.1603 17.4407 20.3359 16.9987 20.3359H6.9987C6.55667 20.3359 6.13275 20.1603 5.82019 19.8478C5.50763 19.5352 5.33203 19.1113 5.33203 18.6693V7.0026C5.33203 6.56058 5.50763 6.13665 5.82019 5.82409C6.13275 5.51153 6.55667 5.33594 6.9987 5.33594H8.66536",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4453 11.1641H15.3342",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4453 15.3359H15.3342",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66797 11.1641H8.67547",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66797 15.3359H8.67547",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyingPlan);
export default __webpack_public_path__ + "static/media/buying_plan.e51868c6b718b1ae3b5c572ce8832da2.svg";
export { ForwardRef as ReactComponent };